<mat-progress-bar [class.invisible]="!ShowProgressBar" mode="indeterminate"></mat-progress-bar>

<div class="tab-toolbar">
    <div class="tab-toolbar__title">Enrollments</div>
    <div class="tab-toolbar__actions">
        <mat-checkbox *ngIf="enrollmentsToLoad == 'Non-Unit'" [(ngModel)]="sendNonUnitPrivateParam"
                      (change)="updateGetData()">Non Unit Private</mat-checkbox>

        <mat-checkbox *ngIf="enrollmentsToLoad == 'Non-Unit'" [(ngModel)]="sendNonUnitGroupParam"
                      (change)="updateGetData()">Non Unit Group</mat-checkbox>

        <button *ngIf="_permissionsService.canAccess('enrollments_create')" class="enrollment" mat-flat-button
            color="primary"
            (click)="openEnrollment()" mat-button>
            Add Enrollment
        </button>
    </div>
</div>

<div class="row">
    <div class="col-12">
        <div class="table-responsive">
            <div class="overflow-auto">
                <table mat-table #displayTable [dataSource]="dataSource"
                    matSort
                    (matSortChange)="sortData($event)"
                    class="mt-4 w-100">

                    <!-- enrollmentID Column -->
                    <ng-container matColumnDef="enrollmentID">
                        <th mat-header-cell *matHeaderCellDef
                            sortActionDescription="Sort by enrollmentID">
                            ID
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <span *ngIf="!element.isAdjustmentRow">{{element.id}}</span>
                            <span *ngIf="element.isAdjustmentRow" class="adjustment-label">Adjustment</span>
                        </td>
                    </ng-container>
                    <!-- field_contacts Column -->
                    <ng-container matColumnDef="field_contacts">
                        <th mat-header-cell *matHeaderCellDef
                            sortActionDescription="Sort by field_contacts">
                            Student
                        </th>
                        <td mat-cell *matCellDef="let element"> {{element.field_contacts}}
                        </td>
                    </ng-container>

                    <!-- field_sale_date Column -->
                    <ng-container matColumnDef="field_sale_date">
                        <th mat-header-cell *matHeaderCellDef
                            sortActionDescription="Sort by field_sale_date">
                            Sale Date
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <ng-container *ngIf="!element.isAdjustmentRow">
                                {{ reportDateService.formatDate(element.field_sale_date) }}
                            </ng-container>
                            <ng-container *ngIf="element.isAdjustmentRow">
                                {{ reportDateService.formatDate(element.field_dropped_date) }}
                            </ng-container>
                        </td>
                    </ng-container>

                    <!-- field_instructor Column -->
                    <ng-container matColumnDef="field_instructor">
                        <th mat-header-cell *matHeaderCellDef
                            sortActionDescription="Sort by field_instructor">
                            Instructor
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <ng-container *ngIf="!element.isAdjustmentRow">
                                {{ element.field_first_name | htmlDecode }} {{ element.field_last_name | htmlDecode }}
                            </ng-container>
                            <ng-container *ngIf="element.isAdjustmentRow">
                                {{ element.field_first_name | htmlDecode }} {{ element.field_last_name | htmlDecode }}
                            </ng-container>
                        </td>
                    </ng-container>

                    <!-- field_category Column -->
                    <ng-container matColumnDef="field_category">
                        <th mat-header-cell *matHeaderCellDef
                            sortActionDescription="Sort by field_category">
                            Category
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <ng-container *ngIf="!element.isAdjustmentRow">
                                {{ element.field_category }}
                            </ng-container>
                            <ng-container *ngIf="element.isAdjustmentRow">
                                <span class="adjustment-label">{{ element.field_category }} (Adjustment)</span>
                            </ng-container>
                        </td>
                    </ng-container>

                    <!-- field_package_name Column -->
                    <ng-container matColumnDef="field_package_name">
                        <th mat-header-cell *matHeaderCellDef
                            sortActionDescription="Sort by field_package_name">
                            Package Name
                        </th>
                        <td mat-cell *matCellDef="let element"> {{ element.field_enrollment_package_name }} </td>
                    </ng-container>

                    <!-- field_enrollment_lesson_count Column -->
                    <ng-container matColumnDef="field_enrollment_lesson_count">
                        <th mat-header-cell *matHeaderCellDef
                            sortActionDescription="Sort by field_enrollment_lesson_count">
                            # of Lessons
                        </th>
                        <td mat-cell *matCellDef="let element" [ngClass]="{'adjustment-value': element.isAdjustmentRow}">
                            <ng-container *ngIf="!element.isAdjustmentRow">
                                {{element.field_enrollment_lesson_count }}
                            </ng-container>
                            <ng-container *ngIf="element.isAdjustmentRow">
                                <div class="adjustment-container">
                                    <div class="adjustment-value">{{ element.adjustmentLessonCount }}</div>
                                    <div class="adjustment-total">= {{ element.finalLessonCount }}</div>
                                </div>
                            </ng-container>
                        </td>
                    </ng-container>

                    <!-- field_enrollment_total_price Column -->
                    <ng-container matColumnDef="field_enrollment_total_price">
                        <th mat-header-cell *matHeaderCellDef class="text-end"
                            sortActionDescription="Sort by field_enrollment_total_price">
                            Total Price
                        </th>
                        <td mat-cell *matCellDef="let element" [ngClass]="{'adjustment-value': element.isAdjustmentRow}" class="text-end">
                            <ng-container *ngIf="!element.isAdjustmentRow && element.field_enrollment_total_price">
                                <ng-container *ngIf="element.withTax?.totalTax; else priceNoTax">
                                    {{ element.withTax.total | studioCurrency }}
                                    <small class="d-block text-muted text-nowrap">{{ element.field_enrollment_total_price | studioCurrency }} + {{ element.withTax.totalTax | studioCurrency }} {{ taxMode?.label }}</small>
                                </ng-container>
                                <ng-template #priceNoTax>{{ element.field_enrollment_total_price | studioCurrency }}</ng-template>
                            </ng-container>
                            <ng-container *ngIf="element.isAdjustmentRow">
                                <div class="adjustment-container">
                                    <div class="adjustment-value">{{ element.adjustmentTotalPrice | studioCurrency }}</div>
                                    <div class="adjustment-total">= {{ element.finalTotalPrice | studioCurrency }}</div>
                                </div>
                            </ng-container>
                        </td>
                    </ng-container>

                    <!-- field_total_paid Column -->
                    <ng-container matColumnDef="field_total_paid">
                        <th mat-header-cell *matHeaderCellDef class="text-end"
                            sortActionDescription="Sort by field_total_paid">
                            Total Paid
                        </th>
                        <td mat-cell *matCellDef="let element" [ngClass]="{'adjustment-value': element.isAdjustmentRow}" class="text-end">
                            <ng-container *ngIf="!element.isAdjustmentRow && element.field_total_payments_made">
                                <ng-container *ngIf="element.withTax?.paidTax; else paidNoTax">
                                    {{ element.withTax.paid | studioCurrency }}
                                    <small class="d-block text-muted text-nowrap">{{ element.field_total_payments_made | studioCurrency }} + {{ element.withTax.paidTax | studioCurrency }} {{ taxMode?.label }}</small>
                                </ng-container>
                                <ng-template #paidNoTax>{{ element.field_total_payments_made | studioCurrency }}</ng-template>
                            </ng-container>
                            <ng-container *ngIf="element.isAdjustmentRow">
                                <div class="adjustment-container">
                                    <div class="adjustment-value">{{ element.adjustmentTotalPaid | studioCurrency }}</div>
                                    <div class="adjustment-total">= {{ element.finalTotalPaid | studioCurrency }}</div>
                                </div>
                            </ng-container>
                        </td>
                    </ng-container>

                    <!-- field_balance_due Column -->
                    <ng-container matColumnDef="field_balance_due">
                        <th mat-header-cell *matHeaderCellDef class="text-end"
                            sortActionDescription="Sort by field_balance_due">
                            Total Due
                        </th>
                        <td mat-cell *matCellDef="let element" [ngClass]="{'adjustment-value': element.isAdjustmentRow}" class="text-end">
                            <ng-container *ngIf="!element.isAdjustmentRow && element.field_balance_due">
                                <ng-container *ngIf="element.withTax?.dueTax; else dueNoTax">
                                    {{ element.withTax.due | studioCurrency }}
                                    <small class="d-block text-muted text-nowrap">{{ element.field_balance_due | studioCurrency }} + {{ element.withTax.dueTax | studioCurrency }} {{ taxMode?.label }}</small>
                                </ng-container>
                                <ng-template #dueNoTax>{{ element.field_balance_due | studioCurrency }}</ng-template>
                            </ng-container>
                            <ng-container *ngIf="element.isAdjustmentRow">
                                <div class="adjustment-container">
                                    <div class="adjustment-value">{{ element.adjustmentBalanceDue | studioCurrency }}</div>
                                    <div class="adjustment-total">= {{ element.finalBalanceDue | studioCurrency }}</div>
                                </div>
                            </ng-container>
                        </td>
                    </ng-container>

                    <!-- field_additional_notes Column -->
                    <ng-container matColumnDef="field_additional_notes">
                        <th mat-header-cell *matHeaderCellDef
                            sortActionDescription="Sort by field_additional_notes">
                            Last Paid
                        </th>
                        <td mat-cell *matCellDef="let element"> {{ reportDateService.formatDate(element.field_last_paid_date != "" ? element.field_last_paid_date : element.field_additional_notes) }} </td>
                    </ng-container>

                    <!-- field_lesson_available Column -->
                    <ng-container matColumnDef="field_lesson_available">
                        <th mat-header-cell *matHeaderCellDef
                            sortActionDescription="Sort by field_lesson_available">
                            Lessons Available
                        </th>
                        <td mat-cell *matCellDef="let element" [ngClass]="{'adjustment-value': element.isAdjustmentRow}" [style.color]="element.field_lesson_available < 0 ? 'red' : ''">
                            {{ +element.field_lesson_available }} </td>
                    </ng-container>

                    <!-- field_lesson_available Column -->
                    <ng-container matColumnDef="isDropped">
                        <th mat-header-cell *matHeaderCellDef
                            sortActionDescription="Sort by field_lesson_available">
                            Drop
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <ng-container *ngIf="!element.isAdjustmentRow">
                                <span class="text-nowrap">{{ element.field_dropped_date ? '✓' : ''  }} {{ reportDateService.formatDate(element.field_dropped_date) }}</span>
                            </ng-container>
                        </td>
                    </ng-container>

                    <!-- nothing Column -->
                    <!-- <ng-container matColumnDef="nothing">
                        <th mat-header-cell *matHeaderCellDef
                            sortActionDescription="Sort by nothing">
                            Hide
                        </th>
                        <td mat-cell *matCellDef="let element">
                        </td>
                    </ng-container> -->

                    <mat-menu #enrollmentMenu="matMenu">
                        <ng-template matMenuContent let-enrollmentID="enrollmentID" let-student_account_id="student_account_id" let-balance_due="balance_due">
                            <button mat-menu-item
                                (click)="openEntityComponent(EnrollmentEntityComponent, 'packages', 'enrollment', '0', enrollmentID)"
                                >
                                View
                            </button>
                            <button *ngIf="_permissionsService.canAccess('enrollments_edit')" mat-menu-item
                                (click)="openEntityComponent(EnrollmentEntityComponent, 'packages', 'enrollment', 'editEnrollment', enrollmentID)"
                                >
                                Edit
                            </button>
                            <button *ngIf="_permissionsService.canAccess('enrollments_edit')" mat-menu-item
                                (click)="openEntityComponent(SignatureEnrollmentComponent, 'packages', 'enrollment', 'signEnrollment', enrollmentID)"
                                >
                                Sign
                            </button>
                            <button *ngIf="_permissionsService.canAccess('enrollments_cancel')" mat-menu-item
                                (click)="openEntityComponent(EnrollmentEntityComponent, 'packages', 'enrollment', 'delete', enrollmentID)"
                                >
                                Delete
                            </button>
                            <button *ngIf="_permissionsService.canAccess('enrollments_cancel')" mat-menu-item
                                (click)="openEntityComponent(EnrollmentDropComponent, 'packages', 'enrollment', 'drop', enrollmentID)"
                                >
                                Drop
                            </button>
                            <button *ngIf="_permissionsService.canAccess('payments_collect')" mat-menu-item
                                [disabled]="balance_due === undefined || balance_due === null || balance_due === '' || +balance_due !== +balance_due || +balance_due === 0"
                                [matTooltip]="balance_due === undefined || balance_due === null || balance_due === '' || +balance_due !== +balance_due || +balance_due === 0 ? 'Cannot add payment: no balance due' : ''"
                                [matTooltipDisabled]="!(balance_due === undefined || balance_due === null || balance_due === '' || +balance_due !== +balance_due || +balance_due === 0)"
                                (click)="openEntityComponent(PaymentsEntityComponent, 'payments', 'payment', 'create', null, { field_enrollment_name: [{ target_id: enrollmentID, payment_amount: 0 }], field_student_name: student_account_id })"
                                >
                                Add Payment
                            </button>
                            <button *ngIf="_permissionsService.canAccess('payments_refund')" mat-menu-item
                                (click)="openEntityComponent(PaymentsEntityComponent, 'payments', 'payment', 'refund', null, {field_gross_tuition: '', field_enrollment_name: {target_id: enrollmentID }, field_student_name: student_account_id, field_payment_type: '71'})"
                                >
                                Refund
                            </button>
                            <button mat-menu-item
                                (click)="openEntityComponentXL(EnrollmentViewLessonComponent, 'packages', 'enrollment', '0', enrollmentID, enrollmentID)"
                                >
                                View Lessons
                            </button>
                            <button mat-menu-item
                                (click)="openEntityComponent(ViewPaymentsFromEnrollmentComponent, 'packages', 'enrollment', null, enrollmentID)"
                                >
                                View Payments
                            </button>
                            <button mat-menu-item
                                (click)="openEntityComponent(ViewPaymentsDueFromEnrollmentComponent, 'packages', 'enrollment', null, enrollmentID)"
                                >
                                View Payments Due
                            </button>
                            <button *ngIf="_permissionsService.isSuperAdmin()" mat-menu-item
                                (click)="openAdjustmentDialog(enrollmentID)"
                                >
                                Adjust Lessons
                            </button>
                        </ng-template>
                    </mat-menu>

                    <!-- nothing_1 Column -->
                    <ng-container matColumnDef="nothing_1">
                        <th mat-header-cell *matHeaderCellDef
                            sortActionDescription="Sort by nothing_1">
                            Actions
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <button *ngIf="!element.isAdjustmentRow" mat-icon-button [matMenuTriggerFor]="enrollmentMenu" [matMenuTriggerData]="{ enrollmentID: element.id, student_account_id: element.field_contacts + ' (' + element.student_account_id + ')', balance_due: element.field_balance_due }">
                            <mat-icon>more_vert</mat-icon>
                            </button>
                        </td>
                    </ng-container>


                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row matRipple *matRowDef="let row; columns: displayedColumns;"
                        [ngClass]="{
                            'dropped-enrollment': row.field_dropped_date && !row.isAdjustmentRow || row.isAdjustmentRow,
                            'adjustment-row': row.isAdjustmentRow
                        }">
                    </tr>
                </table>
            </div>
        </div>

        <div class="text-center my-3" *ngIf="!ShowProgressBar && !this.data?.['count']">
            <div class="alert alert-info">
                No enrollments are available.
            </div>
        </div>

        <div class="d-flex justify-content-center">
            <mat-paginator
                [disabled]="ShowProgressBar"
                (page)="pageChanged($event)"
                [pageSizeOptions]="[data?.['count']]"
                [length]="data?.['count'] || 0"
                [pageSize]="paginationTotalPages"
                [pageIndex]="paginationIndex"
                aria-label="Select page of view">
            </mat-paginator>
        </div>
    </div>
</div>
